import { useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import OperatingHours from "../clinic/operatinghours";
import { useDispatch, useSelector } from "react-redux";
import { getClinicInformation } from "../../reducer/slices/clinic/get-clinicinfo-slice";

import Header from "../common/header/Header";
import { getRecruiterLists } from "../../reducer/slices/recruiter/get-recruiter-slice";
import { getTimezoneList } from "../../reducer/slices/timezone/get-timezone-slice";
import { getWorkflowTrialById } from "../../reducer/slices/workflow/get-workflow-by-id";
import { Toast } from "../common/toast/toast";
import { getClinicInfoById } from "../../js/api/clinic";
import { getCountryStateInformation } from "../../reducer/slices/country-state/get-country-info-slice";
import MultiSelectWithCheckboxWorkflowEdit from "./multiselect-workflow";

import ImageUploader from "../common/image-upload/image-upload";
import GetOpHours from "../clinic/read-operating-hours";
import DragDropList from "../../components/common/dragdropList/dragdropList";
import MetaAdsIntegration from "./meta-ads-integration";
import EditTrialsList from "./edit-trial-list";
import { fetchMetaIntegrationExistDataSlice } from "../../reducer/slices/meta-integration/meta-integration-slice";
import { ROLES } from "../common/constant/roles";
import { useHasRole } from "../../guards/useHasRole";
import PatientScreening from "./patient-screening";
import { EditTrialsBackButton } from "../common/back-button/edit-trial-back";



const WorkflowDetails = () => {
  // All state initialise ----------------------
  const { id } = useParams();

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Trial Configuration')
  const clinicData = useSelector(state => state.clinic_info.data)
  const isAdmin = useHasRole([ROLES.ADMIN]);
  const recruiterData = useSelector((state) => state.recruiter_list?.data || {});
  const timezoneData = useSelector((state) =>
    [...state.time_zone.data].sort((a, b) => a.displayName.localeCompare(b.displayName))
  );
  const diseaseData = useSelector((state) => state.disease_by_clinic_id.data)
  const workflowData = useSelector(state => state.workflow_by_trial_id?.data || [])
  const trialList = useSelector((state) => state.trails_name.data);
  const { loading } = useSelector(state => state.workflow_by_trial_id || [])
  const [trialName, setTrialName] = useState("");
  const [disease, setDisease] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [principalInvestigator, setPrincipalInvestigator] = useState("");
  const [address, setAddress] = useState("");
  const [trialInformation, setTrialInformation] = useState("");
  const [toasts, setToasts] = useState([]);
  const [selectedRecruiterName, setSelectedRecruiterName] = useState([]);
  const [indication, setIndication] = useState("")
  const [apiLoader, setApiLoader] = useState(false)
  const [trialTintroDeleteHover, setTrialIntrDeleteoHover] = useState(false)
  const [trialTrialQuestionDeleteHover, setTrialQuestionDeleteHover] = useState(false)
  const [selectedClinicId, setSelectedClinicId] = useState("");
  const [selectedClinicName, setSelectedClinicName] = useState("")
  const [selectedDiseaseId, setSelectedDiseaseId] = useState("");
  const [selectedDiseaseName, setSelectedDiseaseName] = useState("");
  const [selectedRecruiterId, setSelectedRecruiterId] = useState([]);
  const [selectedIds, setSelectedIds] = useState([])
  const [selectedNames, setSelectedNames] = useState([])
  const [selectCountry, setSelectCountry] = useState("")
  const countryData = useSelector(state => state.country.countryData)
  const [selectedCountryId, setSelectedCountryId] = useState("")
  const [stateList, setStateList] = useState();
  const [selectStateName, setSelectStateName] = useState("")
  const [selectedStateId, setSelectedStateId] = useState("")
  const [city, setCity] = useState('')
  const [postal, setPostal] = useState('')
  const [error, setErrors] = useState({})
  const [getDataOp, setgetDataOp] = useState([]);
  const [inputResponse, setInputResponse] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTimeZoneId, setSelectedTimeZoneId] = useState("");
  const [selectedTimeZoneName, setSelectedTimeZoneName] = useState("");
  const [trialDraggable, setTrialDraggable] = useState(false);
  const [questionDraggable, setQuestionDraggable] = useState(false);
  const [editMode, setEditMode] = useState(false);
  // const [isFbIntegration, setIsFbIntegration] = useState({ integrationExist: false });
  const isFbIntegration = (useSelector(state => state.meta.data) && isAdmin) ? { integrationExist: true } : { integrationExist: false }


  const [trialIntroductions, setTrialIntroductions] = useState([
    {
      trialIntroductionLabel: "",
      trialIntroductionText: "",
      trialIntroductionFollowUp: false,
      trialIntroductionNewImage: 0,
    },
  ]);
  const [trialQuestion, setTrialQuestion] = useState([
    {
      trialQuestionNumber: 1,
      trialQuestionText: "",
      trialQuestionType: true,
    },
  ]);
  const [dnqMessage, setDnqMessage] = useState("");
  const [bookedMessage, setBookedMessage] = useState("");
  const [assignedRecruiter, setAssignedRecruiter] = useState("");
  const dispatch = useDispatch()


  const [selectedImage, setSelectedImage] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const [fileUploadNum, setFileUploadNum] = useState()
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTrialId, setSelectedTrialId] = useState(id);
  const [tabCount, setTabCount] = useState(0);

  const updateHandleImageChange = (index, field, value, file) => {
    const updatedIntroductions = [...trialIntroductions];
    updatedIntroductions[index][field] = value ? value : 0;
    updatedIntroductions[index]["trialIntroductionImageUrl"] = file ? URL.createObjectURL(file) : null;
    setTrialIntroductions(updatedIntroductions);
  };

  useEffect(() => {
    dispatch(getClinicInformation({}))
    dispatch(getCountryStateInformation({}));
    dispatch(getTimezoneList({}))
  }, [])

  useEffect(() => {
    if (id) {
      dispatch(getWorkflowTrialById({ id }));
    } else if (trialList.length > 0) {
      dispatch(getWorkflowTrialById({ id: trialList[0].trialID }));
    }
  }, [id, trialList]);




  const handleChange = (index, field, value) => {
    const updatedIntroductions = [...trialIntroductions];
    updatedIntroductions[index][field] = value;
    setTrialIntroductions(updatedIntroductions);
  };

  const handleFileChange = (index, file) => {
    const updatedIntroductions = [...trialIntroductions];
    updatedIntroductions[index].trialIntroductionNewImage = file;
    setTrialIntroductions(updatedIntroductions);
  };

  const handleTrialOrderChange = (newOrder) => {
    setTrialIntroductions(newOrder);
  };

  const handleQuestionOrderChange = (newOrder) => {
    setTrialQuestion(newOrder);
  };


  const addRow = () => {
    setTrialIntroductions([
      ...trialIntroductions,
      {
        trialIntroductionLabel: "",
        trialIntroductionText: "",
        trialIntroductionFollowUp: false,
        trialIntroductionNewImage: 0,
      },
    ]);
  };

  const deleteRow = (index) => {
    const updatedIntroductions = trialIntroductions.filter((_, i) => i !== index);
    setTrialIntroductions(updatedIntroductions);
  };
  // addition and deletion of the INTRODUCT TEXT ENDS --------------------
  async function getClinicInformationById(clinicId) {
    try {
      const clinicInfo = await getClinicInfoById(clinicId);
      setSelectedClinicName(clinicInfo.data.name)
    } catch (error) {

      console.error('Failed to fetch clinic information');
    }
  }

  const handleQuestionChange = (index, field, value) => {
    setTrialQuestion((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );
  };

  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  const addQuestionRow = () => {
    setTrialQuestion((prev) => [
      ...prev,
      {
        trialQuestionNumber: prev.length + 1,
        trialQuestionText: "",
        trialQuestionType: true,
      },
    ]);
  };

  const removeQuestionRow = (index) => {
    setTrialQuestion((prev) =>
      prev.filter((_, i) => i !== index).map((item, i) => ({
        ...item,
        trialQuestionNumber: i + 1, // Update the numbers sequentially after deletion
      }))
    );
  };
  // addition and deletion of the rows END -----------------

  // Get all the CLINICS -------------------------
  const [clinicInfo, getClinicInfo] = useState([]);

  const fetchClinicData = async () => {
    await axios.get(ENDPOINTS.CLINIC.CLINIC_INFO)
      .then(res => {
        const response = JSON.stringify(res.data.data);
        getClinicInfo(JSON.parse(response));
      })
  };

  const handleSelectCountryChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setSelectCountry(selectedName)

    if (countryData && countryData.length) {
      const selectedTimeZone = countryData.find((tz) => tz.countryName === selectedName);
      selectedTimeZone && selectedTimeZone.countryID && setSelectedCountryId(selectedTimeZone.countryID)
      selectedTimeZone && selectedTimeZone.stateResponseModel && selectedTimeZone.stateResponseModel.length && setStateList(selectedTimeZone.stateResponseModel)
    }
  };

  const handleSelectStateChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setSelectStateName(selectedName)
    const stateAndCountryId = getCountryAndStateId(countryData, selectedName)
    setSelectedCountryId(stateAndCountryId.countryID)
    setSelectedStateId(stateAndCountryId.stateID)
  };

  function getCountryAndStateId(data, stateName) {
    for (const country of data) {
      const state = country.stateResponseModel.find(
        (state) => state.stateName.toLowerCase() === stateName.toLowerCase()
      );
      if (state) {
        return {
          countryID: country.countryID,
          stateID: state.stateID,
        };
      }
    }
    return null; // Return null if no matching state is found
  }

  const handleSelectClinicChange = (e) => {
    const selectedName = e.target.value;

    setSelectedClinicName(selectedName)
    const selectedClinic = clinicInfo.find((clinic) => clinic.name === selectedName);


    if (selectedClinic) {
      const selectedId = selectedClinic.clinicalInfoID;
      setSelectedClinicId(selectedId);

    } else {
      // console.error('Selected clinic not found!');
    }
  };

  const handleSelectClinicChangeById = (id) => {
    const selectedClinic = clinicInfo.find((clinic) => clinic.clinicalInfoID === id);
    if (selectedClinic) {
      const selectedName = selectedClinic.name;
      return selectedName;
    } else {
      return null; // Return null if not found
    }
  };

  const handleRecruiterChange = ({ selectedIds, selectedNames }) => {

    if (selectedIds.length) {
      const arr = []
      for (let index = 0; index < selectedIds.length; index++) {
        const id = selectedIds[index];
        const label = selectedNames[index]
        const value = selectedNames[index]
        const obj = { id, label, value }
        arr.push(obj)
      }
      setSelectedOptions(arr)
    }
    setSelectedIds(selectedIds);
    setSelectedNames(selectedNames);
    setSelectedRecruiterId(selectedIds);
    setSelectedRecruiterName(selectedNames);
  };

   const recruiterOptions = (recruiterData && recruiterData.items && recruiterData.items.length > 0) ? recruiterData.items
        .filter((item) => item.isActive) // Filter active recruiters
        .map((item) => ({
          value: `${item.firstName} ${item.lastName}-${item.recruiterID}`, // Unique value
          label: `${item.firstName} ${item.lastName}`, // Display name
          id: item.recruiterID, // Keep id for tracking
        }))
      : [];

  const setRecruiter = () => {
    const recruiterObj = JSON.stringify({ recruiterID: selectedRecruiterId, selectedName: selectedRecruiterName });
    handleRecruiterChange(recruiterObj, true)
  }

  useEffect(() => {
    const clinicId = selectedClinicId
    dispatch(getRecruiterLists({ clinicId }));

  }, [selectedClinicId])

  function getCheckedDayTime(schedule) {
    const checkedDay = schedule.find(day => day.isChecked);
    if (checkedDay) {
      const { day, time } = checkedDay;
      return `${day.charAt(0).toUpperCase() + day.slice(1)}   ${time.from} - ${time.to}`;
    }
    return "No days are checked";
  }

  function addTrialPrefix(obj) {
    const newObj = {};
    for (const key in obj) {
      // Exclude the key 'trialIntroductionID'
      if (key === 'trialIntroductionID') {
        newObj[key] = obj[key]; // Retain the original key-value pair
      } else {
        newObj[`trial${key.charAt(0).toUpperCase()}${key.slice(1)}`] = obj[key];
      }

      if (key === "introductionImage") {
        newObj["trialIntroductionNewImage"] = obj[key];
      }
    }
    return newObj;
  }


  useEffect(() => {
    setTrialName(workflowData.trialName)
    setSelectedClinicId(workflowData.clinicalInfoID)
    setSelectedDiseaseId(workflowData.diseaseID)
    setPhoneNumber(workflowData.phoneNumber)
    setPrincipalInvestigator(workflowData.principalInvestigator)
    // setSelectedTimeZoneId(workflowData.timezoneID)
    if (workflowData && workflowData.timeZoneModel && workflowData.timeZoneModel.timezoneID) {

      const timeZoneName = getTimezoneNameById(workflowData.timeZoneModel.timezoneID)
      setSelectedTimeZoneName(timeZoneName)
      setSelectedTimeZoneId(workflowData.timeZoneModel.timezoneID)
    }
    setIndication(workflowData.indication)
    setAddress(workflowData.address)
    setTrialInformation(workflowData.trialInformation)
    setDnqMessage(workflowData.dnqMessage)
    setBookedMessage(workflowData.bookedMessage)
    if (workflowData && workflowData.assignedRecruiter && workflowData.assignedRecruiter.length) {
      const rName = workflowData.assignedRecruiter[0];
      const sRI = []
      const sRN = []
      workflowData.assignedRecruiter.map((data, idx) => {
        sRI.push(data.recruiterID)
        sRN.push(data.fullName)
      });
      handleRecruiterChange({
        selectedIds: sRI,
        selectedNames: sRN
      })
    }

    setSelectedCountryId(workflowData.countryID)
    setSelectedStateId(workflowData.stateID)
    setSelectStateName(workflowData.stateName)
    setSelectCountry(workflowData.countryName)
    setPostal(workflowData.zip)
    setCity(workflowData.city)
    handleSelectCountryChange({ target: { value: workflowData.countryName } })

    if (workflowData.operatingHoursJson) {
      // const dateTime = getCheckedDayTime(workflowData.operatingHoursJson);
      const operatingHoursString = GetOpHours({ operatingHours: workflowData.operatingHoursJson })

      setgetDataOp(workflowData.operatingHoursJson)
      setInputResponse(operatingHoursString)
    }
    if (workflowData.trialQuestion) {
      setTrialQuestion(workflowData.trialQuestion)
    }
    if (workflowData.trialIntroduction) {

      const trialIntroduction = workflowData.trialIntroduction.map(trial => {
        return addTrialPrefix(trial); // Ensure addTrialPrefix returns the modified object
      });

      if (trialIntroduction.length != 0) {
        setTrialIntroductions(trialIntroduction);
      }
      // Update to use the converted array
    }

    // handleSelectStateChange({target:{value:workflowData.stateName}})
  }, [workflowData, countryData, recruiterData])

  useEffect(() => {
    getClinicInformationById(selectedClinicId)
  }, [selectedClinicId])

  useEffect(() => {
    fetchClinicData()
    dispatch(fetchMetaIntegrationExistDataSlice({}))
  }, []);



  const addOperatingHours = () => {
    setIsOpen(!isOpen)
  }

  const closePopup = () => {
    setIsOpen(false);
  };

  const handleSelectChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setSelectedTimeZoneName(selectedName)
    const selectedTimeZone = timezoneData.find((tz) => tz.displayName === selectedName);
    setSelectedTimeZoneId(selectedTimeZone.timezoneID)
  };

  const getTimezoneNameById = (id) => {

    const selectedTimeZone = timezoneData.find((tz) => tz.timezoneID === id);

    if (selectedTimeZone) {
      const selectedName = selectedTimeZone.timezoneName; // Extract the name of the selected timezone

      return selectedName; // Return the name
    } else {
      return null; // Return null if not found
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!selectedClinicId) {
      newErrors.location = "Location is required";
    }

    if (!trialName) {
      newErrors.trialName = "Trial name is required.";
    }

    if (!indication) {
      newErrors.indication = "Indication name is required.";
    }

    if (!phoneNumber) {
      newErrors.phoneNumber = "Phone number is required.";
    } else if (!/^\d{10}$/.test(phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be 10 digits.";
    }

    if (!trialInformation) {
      newErrors.trialInformation = "Trial Information is required.";
    }

    if (!selectedIds.length) {
      newErrors.assignRecruiters = "Assign Recruiters is required.";
    }

    if (!principalInvestigator) {
      newErrors.principalInvestigator = "Principal Investigator  is required.";
    }

    if (!selectedTimeZoneName) {
      newErrors.selectedTimeZoneName = "Time Zone is required.";

    }
    if (!inputResponse.length) {
      newErrors.operatingHours = "Operating Hours is required.";
    }

    if (!address) {
      newErrors.address = "Adderess is required.";
    }

    if (!city) {
      newErrors.city = "City is required.";
    }

    if (!selectStateName) {
      newErrors.state = "State is required.";
    }

    if (!selectCountry) {
      newErrors.country = "County is required"
    }

    if (!postal) {
      newErrors.postal = "Zip Code is required"
    }


    for (const trial of trialIntroductions) {
      if (trial && !trial.trialIntroductionLabel) {
        newErrors.trialIntroductionLabel = "Label is Required"
      }
      if (!trial.trialIntroductionText) {
        newErrors.trialIntroductionText = "Intro Text is Required"
      }
    }

    for (const trial of trialQuestion) {
      if (!trial.trialQuestionType) {
        newErrors.questionType = "Question Type is Required"
      }
      if (!trial.trialQuestionText) {
        newErrors.questionText = "Intro Text is Required"
      }
    }

    if (!dnqMessage) {
      newErrors.dnqMessage = "DNQ: Not Qualified Message is required"
    }

    if (!bookedMessage) {
      newErrors.bookedMessage = "On Booked Message is required"
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleAddTrial = async (e) => {

    e.preventDefault();
    if (!validate()) {
      return
    }
    setApiLoader(true)
    const responseBody = {
      clinicalInfoID: selectedClinicId,
      indication: indication,
      trialName,
      phoneNumber,
      principalInvestigator,
      timezoneID: selectedTimeZoneId,
      address,
      operatingHourJson: getDataOp,
      trialInformation,
      trialIntroduction: trialIntroductions.map(intro => ({
        trialIntroductionLabel: intro.trialIntroductionLabel || "string",
        trialIntroductionText: intro.trialIntroductionText || "string",
        trialIntroductionFollowUp: intro.trialIntroductionFollowUp || false,
        trialIntroductionNewImage: intro.trialIntroductionNewImage
      })),
      trialQuestion: trialQuestion.map(question => ({
        trialQuestionNumber: question.trialQuestionNumber || 0,
        trialQuestionText: question.trialQuestionText || "string",
        trialQuestionType: question.trialQuestionType || "string"
      })),
      dnqMessage,
      trialId: id,
      countryID: selectedCountryId,
      stateID: selectedStateId,
      city: city,
      zip: postal,
      onBookedMessage: bookedMessage,
      trialAssignedRecruiterID: selectedIds
    };

    try {


      const response = await axios.put(ENDPOINTS.WORKFLOW.UPDATE_TRIAL, responseBody);
      setApiLoader(false)
      addToast('The Trial has been updated successfully', 'success')

    } catch (error) {

      setApiLoader(false)
      addToast('Failed to update the trial. Please try again.', 'error')
      console.error('Error updating trial:', error.response?.data || error.message);
    }
  };

 
  const [selectedOptions, setSelectedOptions] = useState([]);


  useEffect(() => {
    if (selectedTrialId) {
      navigate(`/trial/${selectedTrialId}`, { replace: true });
      setEditMode(false)
    }
  }, [selectedTrialId]);


  return (
    <>
      <Header headertitle="Edit Trial" backbutton={true} />
      <div className="main-body pt-0 h-[calc(100vh-80px)]">

        {toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
        ))}

        <div className="flex h-[calc(100vh-80px)]">
          <div className="w-[390px]  p-4 pt-[20px]  border-r border-[#B2ACC9] bg-[#F5F5F5]">
            {trialList && trialList.length > 0 && (<>
              <EditTrialsList
                selectedTrialId={selectedTrialId}
                onChangeSelection={(id) => {
                  setSelectedTrialId(id);
                }} />
            </>)}
          </div>

          <div className="flex-1">
            <div className="p-5">
              <span className="font-semibold"> {trialName} </span>
            </div>

            <div className="flex-1 p-5 pb-0 border-t border-[#B2ACC9]">
              {(isFbIntegration.integrationExist || isAdmin) && !editMode && (<>
                <div className="flex cursor-pointer mb-[50px]">
                  <div
                    style={{ color: activeTab === 'Trial Configuration' ? '#245CEA' : '#1A1A1B' }}
                    className="text-[18px] text-center font-semibold font-mont tab"
                    onClick={() => setActiveTab('Trial Configuration')}>
                    Trial Configuration
                    {activeTab === 'Trial Configuration' ? <div className="border-b border-4 h-1 relative top-2 z-10 rounded-sm" style={{ borderColor: "#245CEA" }}></div> : <div className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm" style={{ borderColor: "#C8D6E6" }}></div>}
                  </div>

                  {isFbIntegration.integrationExist ? (<>
                    <div
                      style={{ color: activeTab === 'Trial Configuration' ? '#245CEA' : 'black' }}
                      className="text-[18px] text-center font-semibold"
                    >
                      &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                      <div className=" h-1 border-b border-4 relative top-2 z-10 " style={{ borderColor: "#C8D6E6" }}></div>
                    </div>
                    <div
                      style={{ color: activeTab === 'Meta Ads Integration' ? '#245CEA' : '#1A1A1B', }}
                      className="text-[18px] text-center font-semibold  font-mont tab"
                      onClick={() => setActiveTab('Meta Ads Integration')}
                    >
                      Meta Ads Integration
                      {activeTab === 'Meta Ads Integration' ? <div className="border-b border-4 h-1 relative top-2 z-10 rounded-sm" style={{ borderColor: "#245CEA" }}></div> : <div className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm" style={{ borderColor: "#C8D6E6" }}></div>}
                    </div>
                  </>) : (<></>)}

                  {isAdmin && (<>
                    <div
                      style={{ color: activeTab === 'Trial Configuration' ? '#245CEA' : 'black' }}
                      className="text-[18px] text-center font-semibold"
                    >
                      &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                      <div className=" h-1 border-b border-4 relative top-2 z-10 " style={{ borderColor: "#C8D6E6" }}></div>
                    </div>
                    <div
                      style={{ color: activeTab === 'Trial Information' ? '#245CEA' : '#1A1A1B', }}
                      className="text-[18px] text-center font-semibold  font-mont tab"
                      onClick={() => setActiveTab('Trial Information')}
                    >
                      Trial Information
                      {activeTab === 'Trial Information' ? <div className="border-b border-4 h-1 relative top-2 z-10 rounded-sm" style={{ borderColor: "#245CEA" }}></div> : <div className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm" style={{ borderColor: "#C8D6E6" }}></div>}
                    </div>
                  </>)}
                </div>
              </>)}

            </div>
            <div>
              {
                activeTab === 'Trial Configuration' ? (
                  <>
                    <form>
                      <fieldset disabled={!editMode}>
                      <div className={`p-5 pt-0 overflow-y-auto ${(isFbIntegration.integrationExist || isAdmin) ? "h-[calc(100vh-244px)]" : "h-[calc(100vh-210px)]"}`}>
                        {(isFbIntegration.integrationExist || isAdmin) && !editMode ? "" : <div className="text-[18px] font-mont font-[600]">Trial Information</div>}
                        <div className="border p-5 border-[#C8D6E6] rounded-xl mt-5">
                          <div className="space-y-6" >
                            <div className="grid grid-cols-2 gap-8 pt-0">
                              {/* Clinic Name */}
                              <div className="w-full relative">
                                <label className="block form_label_color mb-3">Location <span className="text-red-600">*</span></label>
                                <select
                                  id="clinic"
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                                  value={selectedClinicName}
                                  onChange={handleSelectClinicChange}
                                >
                                  <option value="" className=" text-gray-400">
                                    Select Location Name
                                  </option>
                                  {clinicData.map((clinic) => (
                                    <option key={clinic.clinicalInfoID} value={clinic.name}>
                                      {clinic.name}
                                    </option>
                                  ))}
                                </select>
                                <span className="absolute right-4 top-[60px] transform -translate-y-1/2 pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </span>
                                {error.location && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.location}</p>}
                              </div>
                              <div className="w-full">
                                <label className="block form_label_color mb-3">Trial Name <span className="text-red-600">*</span></label>
                                <input
                                  type="text"
                                  value={trialName}
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                                  onChange={(e) => setTrialName(e.target.value)}
                                />
                                {error.trialName && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.trialName}</p>}
                              </div>
                            </div>

                            <div className="grid grid-cols-2 gap-8 pt-0">
                              <div className="w-full">

                                <label className="block form_label_color mb-3">Indication <span className="text-red-600">*</span></label>
                                <input
                                  type="text"
                                  value={indication}
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                                  onChange={(e) => setIndication(e.target.value)}
                                />
                                {error.indication && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.indication}</p>}
                              </div>
                              {/* Phone Number */}
                              <div className="w-full">
                                <label className="block form_label_color mb-3">Phone Number <span className="text-red-600">*</span></label>
                                <input
                                  type="text"
                                  value={phoneNumber}
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                                  onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                                {error.phoneNumber && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.phoneNumber}</p>}
                              </div>
                            </div>

                            {/* Trial Information */}
                            <div className="w-full">
                              <label className="block form_label_color mb-3">Trial Information <span className="text-red-600">*</span></label>
                              <textarea
                                value={trialInformation}
                                onChange={(e) => setTrialInformation(e.target.value)}
                                className="border_color border text-base rounded-lg block w-full p-2 h-20"
                              ></textarea>
                              {error.trialInformation && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.trialInformation}</p>}
                            </div>
                            <div className="grid grid-cols-2 gap-8 pt-0">
                              <div className="w-full relative">
                                <label className="block form_label_color mb-3">Assign Recruiter(s) <span className="text-red-600">*</span></label>
                                <div className="  border_color border text-base rounded-lg block w-full p-1 appearance-none" style={{ minHeight: '3rem' }}>
                                  <MultiSelectWithCheckboxWorkflowEdit
                                    isDisabled={!editMode}
                                    options={recruiterOptions}
                                    selectedValues={selectedIds}
                                    onChange={handleRecruiterChange}
                                    selectedIds={selectedIds}
                                    setSelectedIds={setSelectedIds}
                                    selectedNames={selectedNames}
                                    setSelectedNames={setSelectedNames}
                                    selectedOptions={selectedOptions}
                                    setSelectedOptions={setSelectedOptions}
                                  />
                                </div>
                                {error.assignRecruiters && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.assignRecruiters}</p>}
                              </div>
                              {/* Principal Investigator */}
                              <div className="w-full">
                                <label className="block form_label_color mb-3">Principal Investigator <span className="text-red-600">*</span></label>
                                <input
                                  type="text"
                                  value={principalInvestigator}
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12 font-[400]"
                                  onChange={(e) => setPrincipalInvestigator(e.target.value)}
                                />
                                {error.principalInvestigator && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.principalInvestigator}</p>}
                              </div>
                            </div>

                            <div className="grid grid-cols-2 gap-8 pt-0">

                              {/* Timezone */}
                              <div className="w-full relative">
                                <label className="block form_label_color mb-3">Time Zone <span className="text-red-600">*</span></label>
                                <select
                                  id="timezone"
                                  name="timezone"
                                  value={selectedTimeZoneName}
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                                  onChange={handleSelectChange}
                                >
                                  <option value={""} selected disabled>Select Timezone</option>
                                  {timezoneData?.map((tz) => (
                                    <option key={tz.timezoneID} value={tz.displayName}>
                                      {tz.displayName}
                                    </option>
                                  ))}
                                </select>
                                <span className="absolute right-4 top-[60px] transform -translate-y-1/2 pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </span>
                                {error.selectedTimeZoneName && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.selectedTimeZoneName}</p>}
                              </div>

                              {/* Operating Hours */}
                              <div className="w-full relative">
                                <label className="block form_label_color mb-3">Operating Hours <span className="text-red-600">*</span></label>
                                <input
                                  type="text"
                                  name="operatinghours"
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                                  required
                                  placeholder="Add operating hours"
                                  value={inputResponse && inputResponse}
                                  onClick={addOperatingHours}
                                />
                                <span className="absolute right-4 top-[60px] transform -translate-y-1/2 pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.75 8.25C12.75 7.83579 12.4142 7.5 12 7.5C11.5858 7.5 11.25 7.83579 11.25 8.25H12.75ZM9.4543 14.8568C9.17015 15.1582 9.18412 15.6329 9.4855 15.917C9.78689 16.2012 10.2616 16.1872 10.5457 15.8858L9.4543 14.8568ZM2.53148 2.66435C2.20803 2.92311 2.15559 3.39507 2.41435 3.71852C2.67311 4.04197 3.14507 4.09441 3.46852 3.83565L2.53148 2.66435ZM5.96852 1.83565C6.29197 1.57689 6.34441 1.10493 6.08565 0.781479C5.82689 0.458032 5.35493 0.405591 5.03148 0.664348L5.96852 1.83565ZM20.5315 3.83565C20.8549 4.09441 21.3269 4.04197 21.5857 3.71852C21.8444 3.39507 21.792 2.92311 21.4685 2.66435L20.5315 3.83565ZM18.9685 0.664348C18.6451 0.405591 18.1731 0.458032 17.9143 0.781479C17.6556 1.10493 17.708 1.57689 18.0315 1.83565L18.9685 0.664348ZM11.4552 13.8278L10.9095 13.3133L11.4552 13.8278ZM11.25 8.25V12.4558H12.75V8.25H11.25ZM10.5457 15.8858L12.0009 14.3423L10.9095 13.3133L9.4543 14.8568L10.5457 15.8858ZM3.46852 3.83565L5.96852 1.83565L5.03148 0.664348L2.53148 2.66435L3.46852 3.83565ZM21.4685 2.66435L18.9685 0.664348L18.0315 1.83565L20.5315 3.83565L21.4685 2.66435ZM21.25 12.25C21.25 17.3586 17.1086 21.5 12 21.5V23C17.9371 23 22.75 18.1871 22.75 12.25H21.25ZM12 21.5C6.89137 21.5 2.75 17.3586 2.75 12.25H1.25C1.25 18.1871 6.06294 23 12 23V21.5ZM2.75 12.25C2.75 7.14136 6.89137 3 12 3V1.5C6.06294 1.5 1.25 6.31294 1.25 12.25H2.75ZM12 3C17.1086 3 21.25 7.14136 21.25 12.25H22.75C22.75 6.31294 17.9371 1.5 12 1.5V3ZM11.25 12.4558C11.25 12.7746 11.1282 13.0814 10.9095 13.3133L12.0009 14.3423C12.482 13.832 12.75 13.1572 12.75 12.4558H11.25Z" fill="#245CEA"></path></svg>
                                </span>
                                {error.operatingHours && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.operatingHours}</p>}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="text-[18px] font-mont font-[600] mt-5">Address Information</div>
                        <div className="border p-5 border-[#C8D6E6] rounded-xl mt-5">
                          <div className="space-y-6" >
                            <div className="grid gap-8 pt-0">

                              {/* Address */}
                              <div className="w-full">
                                <label className="block form_label_color mb-3">Address <span className="text-red-600">*</span></label>
                                <input
                                  type="text"
                                  value={address}
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                                  onChange={(e) => setAddress(e.target.value)}
                                />
                                {error.address && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.address}</p>}
                              </div>
                            </div>
                            <div className="grid grid-cols-4 gap-6 mt-6" >
                              <div>
                                <label for="principalInvestigator" class="block form_label_color pb-3">
                                  City  <span className="text-red-600">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="principalInvestigator"
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                                  required
                                  // placeholder="Please enter city"
                                  value={city}
                                  onChange={(e) => setCity(e.target.value)}
                                />
                                {error.city && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.city}</p>}
                              </div>
                              <div className="w-full relative">
                                <label className="block form_label_color mb-3">Country/Region <span className="text-red-600">*</span></label>
                                <select
                                  id="countyr"
                                  name="country"
                                  value={selectCountry}
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                                  onChange={handleSelectCountryChange}
                                >
                                  <option value={""} selected></option>
                                  {countryData?.map((tz) => (
                                    <option key={tz.countryID} value={tz.countryName}>
                                      {tz.countryName}
                                    </option>
                                  ))}
                                </select>
                                <span className="absolute right-4 top-[60px] transform -translate-y-1/2 pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </span>
                                {error.country && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.country}</p>}
                              </div>
                              <div className="w-full relative">
                                <label className="block form_label_color mb-3">State <span className="text-red-600">*</span></label>
                                <select
                                  id="state"
                                  name="state"
                                  value={selectStateName}
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12  appearance-none"
                                  onChange={handleSelectStateChange}
                                >
                                  <option value={""} selected></option>
                                  {stateList && stateList.length && stateList.map((tz) => (
                                    <option key={tz.stateID} value={tz.stateName}>
                                      {tz.stateName}
                                    </option>
                                  ))}
                                </select>
                                <span className="absolute right-4 top-[60px] transform -translate-y-1/2 pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </span>
                                {error.state && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.state}</p>}
                              </div>
                              <div>
                                <label for="organization_name" class="block form_label_color pb-3">
                                  Zip Code  <span className="text-red-600">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="organization_name"
                                  className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                                  required
                                  // placeholder="Please enter Postal Code"
                                  value={postal}
                                  onChange={(e) => setPostal(e.target.value)}
                                />
                                {error.postal && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.postal}</p>}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="text-[18px] font-mont font-[600] mt-5">Trial Introduction</div>
                        <div className="border p-2 pt-0 border-[#C8D6E6] rounded-xl mt-5">
                          <div className="space-y-6" >
                            <div className="w-full">
                              {/* <label className="block form_label_color mb-3">Introduction Texts</label> */}

                              <DragDropList
                                items={trialIntroductions}
                                onOrderChange={handleTrialOrderChange}
                                renderItem={({ item: introduction, index, handleDragStart, handleDragOver, handleDrop, handleRemoveItem }) => (
                                  <div key={index}
                                    draggable={trialDraggable}
                                    onDragStart={() => handleDragStart(index)}
                                    onDragOver={handleDragOver}
                                    onDrop={() => handleDrop(index)}
                                    className="intro-row flex space-x-4 mt-4 justify-center items-end">
                                    <label className="block p-2 w-1/4 mb-auto">
                                      <div className="form_label_color mb-3">Label <span className="text-red-600">*</span></div>
                                      <input
                                        type="text"
                                        value={introduction.trialIntroductionLabel}
                                        className="border_color border text-base rounded-lg block w-full p-2.5 h-12 font-[400]"
                                        onChange={(e) => handleChange(index, "trialIntroductionLabel", e.target.value)}
                                      />
                                    </label>
                                    <label className="block w-4/5 p-2">
                                      <div className="form_label_color mb-3">Introduction Text <span className="text-red-600">*</span></div>
                                      <textarea
                                        value={introduction.trialIntroductionText}
                                        className="border_color border text-base rounded-lg block w-full p-2.5 h-20 font-[400]"
                                        onChange={(e) => handleChange(index, "trialIntroductionText", e.target.value)}
                                      />

                                    </label>
                                    <ImageUploader
                                      imgurl={introduction.trialIntroductionImageUrl}
                                      updateHandleImageChange={updateHandleImageChange}
                                      selectedImage={selectedImage}
                                      setSelectedImage={setSelectedImage}
                                      uploadStatus={uploadStatus}
                                      setUploadStatus={setUploadStatus}
                                      isLoading={isLoading}
                                      setIsLoading={setIsLoading}
                                      index={index}
                                      fileUploadNum={fileUploadNum}
                                      setFileUploadNum={setFileUploadNum} />
                                    <label className="block w-[150px] p-2">
                                      <div className=" form_label_color mb-3">
                                        <span className="">Follow Ups</span> <span className="text-red-600">*</span>
                                      </div>
                                      <div
                                        className={`relative inline-flex items-center h-6 w-12 rounded-full cursor-pointer border border-[#A6A6A6] ${introduction.trialIntroductionFollowUp ? "bg-blue-500 border-blue-500" : "bg-[#ffffff]"
                                          }`}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={introduction.trialIntroductionFollowUp}
                                          className="hidden"
                                          onChange={(e) => handleChange(index, "trialIntroductionFollowUp", introduction.trialIntroductionFollowUp ? false : e.target.checked)}
                                        />
                                        <span
                                          className={`inline-block h-[18px] w-[18px] bg-[#A6A6A6] rounded-full transform transition-transform ${introduction.trialIntroductionFollowUp ? "translate-x-6 bg-white" : "translate-x-1"
                                            }`}
                                        ></span>
                                      </div>
                                    </label>

                                    <span
                                      className="draggable w-8 h-8 text-white rounded-full flex items-center justify-center m-2"
                                      onMouseEnter={() => setTrialDraggable(true)}
                                      onMouseLeave={() => setTrialDraggable(false)}
                                    >

                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M8 20C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18C7.44772 18 7 18.4477 7 19C7 19.5523 7.44772 20 8 20Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16 6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5C15 5.55228 15.4477 6 16 6Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16 20C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                      </svg>

                                    </span>

                                    {index === 0 && trialIntroductions.length === 1 ? <button
                                      type="button"
                                      onClick={() => deleteRow(index)}
                                      onMouseEnter={() => { setTrialIntrDeleteoHover(index) }}
                                      onMouseLeave={() => { setTrialIntrDeleteoHover() }}
                                      disabled={true}
                                      className="w-8 h-8 flex item-end">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M18.5172 12.7795L19.26 12.8829L19.26 12.8829L18.5172 12.7795ZM18.2549 14.6645L18.9977 14.7679L18.9977 14.7679L18.2549 14.6645ZM5.74514 14.6645L6.48798 14.5611L6.48798 14.5611L5.74514 14.6645ZM5.4828 12.7795L4.73996 12.8829L4.73996 12.8829L5.4828 12.7795ZM9.18365 21.7368L8.89206 22.4278L8.89206 22.4278L9.18365 21.7368ZM6.47508 18.5603L7.17907 18.3017L7.17907 18.3017L6.47508 18.5603ZM17.5249 18.5603L18.2289 18.819L18.2289 18.819L17.5249 18.5603ZM14.8164 21.7368L14.5248 21.0458L14.5248 21.0458L14.8164 21.7368ZM5.74664 8.92906C5.70746 8.5167 5.34142 8.21418 4.92906 8.25336C4.5167 8.29254 4.21418 8.65858 4.25336 9.07094L5.74664 8.92906ZM19.7466 9.07094C19.7858 8.65858 19.4833 8.29254 19.0709 8.25336C18.6586 8.21418 18.2925 8.5167 18.2534 8.92906L19.7466 9.07094ZM20 7.75C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25V7.75ZM4 6.25C3.58579 6.25 3.25 6.58579 3.25 7C3.25 7.41421 3.58579 7.75 4 7.75V6.25ZM9.25 18C9.25 18.4142 9.58579 18.75 10 18.75C10.4142 18.75 10.75 18.4142 10.75 18H9.25ZM10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10H10.75ZM13.25 18C13.25 18.4142 13.5858 18.75 14 18.75C14.4142 18.75 14.75 18.4142 14.75 18H13.25ZM14.75 10C14.75 9.58579 14.4142 9.25 14 9.25C13.5858 9.25 13.25 9.58579 13.25 10H14.75ZM16 7V7.75H16.75V7H16ZM8 7H7.25V7.75H8V7ZM17.7744 12.6761L17.512 14.5611L18.9977 14.7679L19.26 12.8829L17.7744 12.6761ZM6.48798 14.5611L6.22564 12.6761L4.73996 12.8829L5.0023 14.7679L6.48798 14.5611ZM12 21.25C10.4708 21.25 9.92544 21.2358 9.47524 21.0458L8.89206 22.4278C9.68914 22.7642 10.6056 22.75 12 22.75V21.25ZM5.0023 14.7679C5.282 16.7777 5.43406 17.9017 5.77109 18.819L7.17907 18.3017C6.91156 17.5736 6.77851 16.6488 6.48798 14.5611L5.0023 14.7679ZM9.47524 21.0458C8.55279 20.6566 7.69496 19.7058 7.17907 18.3017L5.77109 18.819C6.3857 20.4918 7.48205 21.8328 8.89206 22.4278L9.47524 21.0458ZM17.512 14.5611C17.2215 16.6488 17.0884 17.5736 16.8209 18.3017L18.2289 18.819C18.5659 17.9017 18.718 16.7777 18.9977 14.7679L17.512 14.5611ZM12 22.75C13.3944 22.75 14.3109 22.7642 15.1079 22.4278L14.5248 21.0458C14.0746 21.2358 13.5292 21.25 12 21.25V22.75ZM16.8209 18.3017C16.305 19.7058 15.4472 20.6566 14.5248 21.0458L15.1079 22.4278C16.5179 21.8328 17.6143 20.4918 18.2289 18.819L16.8209 18.3017ZM6.22564 12.6761C6.00352 11.08 5.83766 9.88703 5.74664 8.92906L4.25336 9.07094C4.34819 10.069 4.51961 11.2995 4.73996 12.8829L6.22564 12.6761ZM19.26 12.8829C19.4804 11.2995 19.6518 10.069 19.7466 9.07094L18.2534 8.92906C18.1623 9.88702 17.9965 11.08 17.7744 12.6761L19.26 12.8829ZM20 6.25H4V7.75H20V6.25ZM10.75 18V10H9.25V18H10.75ZM14.75 18V10H13.25V18H14.75ZM15.25 6V7H16.75V6H15.25ZM16 6.25H8V7.75H16V6.25ZM8.75 7V6H7.25V7H8.75ZM12 2.75C13.7949 2.75 15.25 4.20507 15.25 6H16.75C16.75 3.37665 14.6234 1.25 12 1.25V2.75ZM12 1.25C9.37665 1.25 7.25 3.37665 7.25 6H8.75C8.75 4.20507 10.2051 2.75 12 2.75V1.25Z" fill="#87909E" />
                                      </svg>
                                    </button> : <button
                                      type="button"
                                      onClick={() => deleteRow(index)}
                                      onMouseEnter={() => { setTrialIntrDeleteoHover(index) }}
                                      onMouseLeave={() => { setTrialIntrDeleteoHover() }}
                                      className="w-8 h-8 flex item-end">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6V7H8V6Z" fill="#DC3545" />
                                        <path d="M18.5172 12.7795L19.26 12.8829L18.5172 12.7795ZM18.2549 14.6645L18.9977 14.7679L18.2549 14.6645ZM5.74514 14.6645L6.48798 14.5611L5.74514 14.6645ZM5.4828 12.7795L4.73996 12.8829L5.4828 12.7795ZM9.18365 21.7368L8.89206 22.4278L9.18365 21.7368ZM6.47508 18.5603L7.17907 18.3017L6.47508 18.5603ZM17.5249 18.5603L18.2289 18.819V18.819L17.5249 18.5603ZM14.8164 21.7368L14.5248 21.0458H14.5248L14.8164 21.7368ZM5.74664 8.92906C5.70746 8.5167 5.34142 8.21418 4.92906 8.25336C4.5167 8.29254 4.21418 8.65858 4.25336 9.07094L5.74664 8.92906ZM19.7466 9.07094C19.7858 8.65858 19.4833 8.29254 19.0709 8.25336C18.6586 8.21418 18.2925 8.5167 18.2534 8.92906L19.7466 9.07094ZM20 7.75C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25V7.75ZM4 6.25C3.58579 6.25 3.25 6.58579 3.25 7C3.25 7.41421 3.58579 7.75 4 7.75V6.25ZM9.25 18C9.25 18.4142 9.58579 18.75 10 18.75C10.4142 18.75 10.75 18.4142 10.75 18H9.25ZM10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10H10.75ZM13.25 18C13.25 18.4142 13.5858 18.75 14 18.75C14.4142 18.75 14.75 18.4142 14.75 18H13.25ZM14.75 10C14.75 9.58579 14.4142 9.25 14 9.25C13.5858 9.25 13.25 9.58579 13.25 10H14.75ZM16 7V7.75H16.75V7H16ZM8 7H7.25V7.75H8V7ZM17.7744 12.6761L17.512 14.5611L18.9977 14.7679L19.26 12.8829L17.7744 12.6761ZM6.48798 14.5611L6.22564 12.6761L4.73996 12.8829L5.0023 14.7679L6.48798 14.5611ZM12 21.25C10.4708 21.25 9.92544 21.2358 9.47524 21.0458L8.89206 22.4278C9.68914 22.7642 10.6056 22.75 12 22.75V21.25ZM5.0023 14.7679C5.282 16.7777 5.43406 17.9017 5.77109 18.819L7.17907 18.3017C6.91156 17.5736 6.77851 16.6488 6.48798 14.5611L5.0023 14.7679ZM9.47524 21.0458C8.55279 20.6566 7.69496 19.7058 7.17907 18.3017L5.77109 18.819C6.3857 20.4918 7.48205 21.8328 8.89206 22.4278L9.47524 21.0458ZM17.512 14.5611C17.2215 16.6488 17.0884 17.5736 16.8209 18.3017L18.2289 18.819C18.5659 17.9017 18.718 16.7777 18.9977 14.7679L17.512 14.5611ZM12 22.75C13.3944 22.75 14.3109 22.7642 15.1079 22.4278L14.5248 21.0458C14.0746 21.2358 13.5292 21.25 12 21.25V22.75ZM16.8209 18.3017C16.305 19.7058 15.4472 20.6566 14.5248 21.0458L15.1079 22.4278C16.5179 21.8328 17.6143 20.4918 18.2289 18.819L16.8209 18.3017ZM6.22564 12.6761C6.00352 11.08 5.83766 9.88703 5.74664 8.92906L4.25336 9.07094C4.34819 10.069 4.51961 11.2995 4.73996 12.8829L6.22564 12.6761ZM19.26 12.8829C19.4804 11.2995 19.6518 10.069 19.7466 9.07094L18.2534 8.92906C18.1623 9.88702 17.9965 11.08 17.7744 12.6761L19.26 12.8829ZM20 6.25H4V7.75H20V6.25ZM10.75 18V10H9.25V18H10.75ZM14.75 18V10H13.25V18H14.75ZM15.25 6V7H16.75V6H15.25ZM16 6.25H8V7.75H16V6.25ZM8.75 7V6H7.25V7H8.75ZM12 2.75C13.7949 2.75 15.25 4.20507 15.25 6H16.75C16.75 3.37665 14.6234 1.25 12 1.25V2.75ZM12 1.25C9.37665 1.25 7.25 3.37665 7.25 6H8.75C8.75 4.20507 10.2051 2.75 12 2.75V1.25Z" fill="#DC3545" />
                                      </svg>
                                    </button>}
                                  </div>
                                )}
                              />

                              {error.trialIntroductionLabel || error.trialIntroductionText ? <div className="intro-row flex space-x-4  justify-center items-end">
                                <label className="block p-2 pt-0 w-1/4">
                                  {error.trialIntroductionLabel && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.trialIntroductionLabel}</p>}
                                </label>
                                <label className="block w-4/5 p-2 pt-0 ">
                                  {error.trialIntroductionText && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.trialIntroductionText}</p>}
                                </label>
                                <label className="block w-[150px] p-2 pt-0 ">
                                  <div className=" form_label_color mb-3">
                                  </div>
                                  <div>

                                  </div>
                                </label>
                                <button
                                  type="button"
                                  // onClick={() => deleteRow(index)}
                                  className="w-8 h-8 flex item-end">
                                </button>
                              </div> : ''}
                              <button type="button" onClick={addRow} className="flex mt-2 items-center ml-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                  <path d="M9 1V17" stroke="#245CEA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M1 9H17" stroke="#245CEA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg> <span className="ml-2 font-mont text-[16px] font-[600] text-[#245CEA]">Add Introduction Text</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="text-[18px] font-mont font-[600] mt-5">Inclusion/Exclusion</div>
                        <div className="border p-5 pt-0 pr-3 border-[#C8D6E6] rounded-xl mt-3">
                          <div className="space-y-6">
                            <div className="w-full">

                            <DragDropList
              items={trialQuestion}
              onOrderChange={handleQuestionOrderChange}
              renderItem={({ item: introduction, index, handleDragStart, handleDragOver, handleDrop, handleRemoveItem }) => (
                <div
                  key={index}
                  draggable={questionDraggable}
                  onDragStart={() => handleDragStart(index)}
                  onDragOver={handleDragOver}
                  onDrop={() => handleDrop(index)}
                >


                  <div className="relative flex items-center space-x-1 mt-4">
                    <div
                      className="w-1/5 p-2 pb-0 pl-0 h-10 appearance-none"

                    >
                      <label className="form_label_color">
                        Question Type <span className="text-red-600">*</span>
                      </label>
                    </div>
                    <div className="w-3/5 pl-3"><label className="form_label_color">
                      Question <span className="text-red-600">*</span>
                    </label></div>

                  </div>
                  <div key={index} className="question-row relative flex items-center space-x-1">
                    <select
                      value={introduction.trialQuestionType}
                      className="border_color border text-base rounded-lg block w-1/4 p-2.5 h-12 appearance-none"
                      onChange={(e) => handleQuestionChange(index, "trialQuestionType", e.target.value)}
                    >
                      <option value="" disabled selected>Select Question Type</option>
                      <option value="Inclusion">Inclusion</option>
                      <option value="Exclusion">Exclusion</option>
                      <option value="Neutral">Neutral</option>
                    </select>
                    <span className="relative right-[50px] top-[10px] transform -translate-y-1/2 pointer-events-none">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                    <input
                      type="text"
                      placeholder={`Question ${index + 1}`}
                      value={introduction.trialQuestionText}
                      onChange={(e) => handleQuestionChange(index, "trialQuestionText", e.target.value)}
                      className="border_color border text-base rounded-lg block w-full p-2.5 mr-8 h-12"
                      style={{ marginRight: '30px' }}
                    />
                    <span
                      className="draggable w-8 h-8 text-white rounded-full flex items-center justify-center m-2"
                      onMouseEnter={() => setQuestionDraggable(true)}
                      onMouseLeave={() => setQuestionDraggable(false)}
                    >

                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8 20C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18C7.44772 18 7 18.4477 7 19C7 19.5523 7.44772 20 8 20Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M16 6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5C15 5.55228 15.4477 6 16 6Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M16 20C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>

                    </span>

                    {index === 0 && trialQuestion.length === 1 ? <button
                      type="button"
                      disabled={true}
                      onClick={() => removeQuestionRow(index)}
                      onMouseEnter={() => { setTrialQuestionDeleteHover(index) }}
                      onMouseLeave={() => { setTrialQuestionDeleteHover() }}
                      className="w-8 h-8 text-white rounded-full flex items-center justify-center m-2"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18.5172 12.7795L19.26 12.8829L19.26 12.8829L18.5172 12.7795ZM18.2549 14.6645L18.9977 14.7679L18.9977 14.7679L18.2549 14.6645ZM5.74514 14.6645L6.48798 14.5611L6.48798 14.5611L5.74514 14.6645ZM5.4828 12.7795L4.73996 12.8829L4.73996 12.8829L5.4828 12.7795ZM9.18365 21.7368L8.89206 22.4278L8.89206 22.4278L9.18365 21.7368ZM6.47508 18.5603L7.17907 18.3017L7.17907 18.3017L6.47508 18.5603ZM17.5249 18.5603L18.2289 18.819L18.2289 18.819L17.5249 18.5603ZM14.8164 21.7368L14.5248 21.0458L14.5248 21.0458L14.8164 21.7368ZM5.74664 8.92906C5.70746 8.5167 5.34142 8.21418 4.92906 8.25336C4.5167 8.29254 4.21418 8.65858 4.25336 9.07094L5.74664 8.92906ZM19.7466 9.07094C19.7858 8.65858 19.4833 8.29254 19.0709 8.25336C18.6586 8.21418 18.2925 8.5167 18.2534 8.92906L19.7466 9.07094ZM20 7.75C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25V7.75ZM4 6.25C3.58579 6.25 3.25 6.58579 3.25 7C3.25 7.41421 3.58579 7.75 4 7.75V6.25ZM9.25 18C9.25 18.4142 9.58579 18.75 10 18.75C10.4142 18.75 10.75 18.4142 10.75 18H9.25ZM10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10H10.75ZM13.25 18C13.25 18.4142 13.5858 18.75 14 18.75C14.4142 18.75 14.75 18.4142 14.75 18H13.25ZM14.75 10C14.75 9.58579 14.4142 9.25 14 9.25C13.5858 9.25 13.25 9.58579 13.25 10H14.75ZM16 7V7.75H16.75V7H16ZM8 7H7.25V7.75H8V7ZM17.7744 12.6761L17.512 14.5611L18.9977 14.7679L19.26 12.8829L17.7744 12.6761ZM6.48798 14.5611L6.22564 12.6761L4.73996 12.8829L5.0023 14.7679L6.48798 14.5611ZM12 21.25C10.4708 21.25 9.92544 21.2358 9.47524 21.0458L8.89206 22.4278C9.68914 22.7642 10.6056 22.75 12 22.75V21.25ZM5.0023 14.7679C5.282 16.7777 5.43406 17.9017 5.77109 18.819L7.17907 18.3017C6.91156 17.5736 6.77851 16.6488 6.48798 14.5611L5.0023 14.7679ZM9.47524 21.0458C8.55279 20.6566 7.69496 19.7058 7.17907 18.3017L5.77109 18.819C6.3857 20.4918 7.48205 21.8328 8.89206 22.4278L9.47524 21.0458ZM17.512 14.5611C17.2215 16.6488 17.0884 17.5736 16.8209 18.3017L18.2289 18.819C18.5659 17.9017 18.718 16.7777 18.9977 14.7679L17.512 14.5611ZM12 22.75C13.3944 22.75 14.3109 22.7642 15.1079 22.4278L14.5248 21.0458C14.0746 21.2358 13.5292 21.25 12 21.25V22.75ZM16.8209 18.3017C16.305 19.7058 15.4472 20.6566 14.5248 21.0458L15.1079 22.4278C16.5179 21.8328 17.6143 20.4918 18.2289 18.819L16.8209 18.3017ZM6.22564 12.6761C6.00352 11.08 5.83766 9.88703 5.74664 8.92906L4.25336 9.07094C4.34819 10.069 4.51961 11.2995 4.73996 12.8829L6.22564 12.6761ZM19.26 12.8829C19.4804 11.2995 19.6518 10.069 19.7466 9.07094L18.2534 8.92906C18.1623 9.88702 17.9965 11.08 17.7744 12.6761L19.26 12.8829ZM20 6.25H4V7.75H20V6.25ZM10.75 18V10H9.25V18H10.75ZM14.75 18V10H13.25V18H14.75ZM15.25 6V7H16.75V6H15.25ZM16 6.25H8V7.75H16V6.25ZM8.75 7V6H7.25V7H8.75ZM12 2.75C13.7949 2.75 15.25 4.20507 15.25 6H16.75C16.75 3.37665 14.6234 1.25 12 1.25V2.75ZM12 1.25C9.37665 1.25 7.25 3.37665 7.25 6H8.75C8.75 4.20507 10.2051 2.75 12 2.75V1.25Z" fill="#87909E" />
                      </svg>
                    </button> : <button
                      type="button"
                      onClick={() => removeQuestionRow(index)}
                      onMouseEnter={() => { setTrialQuestionDeleteHover(index) }}
                      onMouseLeave={() => { setTrialQuestionDeleteHover() }}
                      className="w-8 h-8 text-white rounded-full flex items-center justify-center m-2"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6V7H8V6Z" fill="#DC3545" />
                        <path d="M18.5172 12.7795L19.26 12.8829L18.5172 12.7795ZM18.2549 14.6645L18.9977 14.7679L18.2549 14.6645ZM5.74514 14.6645L6.48798 14.5611L5.74514 14.6645ZM5.4828 12.7795L4.73996 12.8829L5.4828 12.7795ZM9.18365 21.7368L8.89206 22.4278L9.18365 21.7368ZM6.47508 18.5603L7.17907 18.3017L6.47508 18.5603ZM17.5249 18.5603L18.2289 18.819V18.819L17.5249 18.5603ZM14.8164 21.7368L14.5248 21.0458H14.5248L14.8164 21.7368ZM5.74664 8.92906C5.70746 8.5167 5.34142 8.21418 4.92906 8.25336C4.5167 8.29254 4.21418 8.65858 4.25336 9.07094L5.74664 8.92906ZM19.7466 9.07094C19.7858 8.65858 19.4833 8.29254 19.0709 8.25336C18.6586 8.21418 18.2925 8.5167 18.2534 8.92906L19.7466 9.07094ZM20 7.75C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25V7.75ZM4 6.25C3.58579 6.25 3.25 6.58579 3.25 7C3.25 7.41421 3.58579 7.75 4 7.75V6.25ZM9.25 18C9.25 18.4142 9.58579 18.75 10 18.75C10.4142 18.75 10.75 18.4142 10.75 18H9.25ZM10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10H10.75ZM13.25 18C13.25 18.4142 13.5858 18.75 14 18.75C14.4142 18.75 14.75 18.4142 14.75 18H13.25ZM14.75 10C14.75 9.58579 14.4142 9.25 14 9.25C13.5858 9.25 13.25 9.58579 13.25 10H14.75ZM16 7V7.75H16.75V7H16ZM8 7H7.25V7.75H8V7ZM17.7744 12.6761L17.512 14.5611L18.9977 14.7679L19.26 12.8829L17.7744 12.6761ZM6.48798 14.5611L6.22564 12.6761L4.73996 12.8829L5.0023 14.7679L6.48798 14.5611ZM12 21.25C10.4708 21.25 9.92544 21.2358 9.47524 21.0458L8.89206 22.4278C9.68914 22.7642 10.6056 22.75 12 22.75V21.25ZM5.0023 14.7679C5.282 16.7777 5.43406 17.9017 5.77109 18.819L7.17907 18.3017C6.91156 17.5736 6.77851 16.6488 6.48798 14.5611L5.0023 14.7679ZM9.47524 21.0458C8.55279 20.6566 7.69496 19.7058 7.17907 18.3017L5.77109 18.819C6.3857 20.4918 7.48205 21.8328 8.89206 22.4278L9.47524 21.0458ZM17.512 14.5611C17.2215 16.6488 17.0884 17.5736 16.8209 18.3017L18.2289 18.819C18.5659 17.9017 18.718 16.7777 18.9977 14.7679L17.512 14.5611ZM12 22.75C13.3944 22.75 14.3109 22.7642 15.1079 22.4278L14.5248 21.0458C14.0746 21.2358 13.5292 21.25 12 21.25V22.75ZM16.8209 18.3017C16.305 19.7058 15.4472 20.6566 14.5248 21.0458L15.1079 22.4278C16.5179 21.8328 17.6143 20.4918 18.2289 18.819L16.8209 18.3017ZM6.22564 12.6761C6.00352 11.08 5.83766 9.88703 5.74664 8.92906L4.25336 9.07094C4.34819 10.069 4.51961 11.2995 4.73996 12.8829L6.22564 12.6761ZM19.26 12.8829C19.4804 11.2995 19.6518 10.069 19.7466 9.07094L18.2534 8.92906C18.1623 9.88702 17.9965 11.08 17.7744 12.6761L19.26 12.8829ZM20 6.25H4V7.75H20V6.25ZM10.75 18V10H9.25V18H10.75ZM14.75 18V10H13.25V18H14.75ZM15.25 6V7H16.75V6H15.25ZM16 6.25H8V7.75H16V6.25ZM8.75 7V6H7.25V7H8.75ZM12 2.75C13.7949 2.75 15.25 4.20507 15.25 6H16.75C16.75 3.37665 14.6234 1.25 12 1.25V2.75ZM12 1.25C9.37665 1.25 7.25 3.37665 7.25 6H8.75C8.75 4.20507 10.2051 2.75 12 2.75V1.25Z" fill="#DC3545" />
                      </svg>
                    </button>}
                  </div>
                </div>

              )} />

                            {/* {trialQuestion.map((introduction, index) => (
                              <>
                                <div className="relative flex items-center space-x-1 mt-4">
                                  <div
                                    className="w-1/5 p-2 pb-0 pl-0 h-10 appearance-none"

                                    >
                                      <label className="form_label_color">
                                        Question Type <span className="text-red-600">*</span>
                                      </label>
                                    </div>
                                    <div className="w-3/5 pl-3"><label className="form_label_color">
                                      Question <span className="text-red-600">*</span>
                                    </label></div>

                                </div>
                                <div key={index} className="question-row relative flex items-center space-x-1">
                                  <select
                                    value={introduction.trialQuestionType}
                                    className="border_color border text-base rounded-lg block w-1/4 p-2.5 h-12 appearance-none"
                                    onChange={(e) => handleQuestionChange(index, "trialQuestionType", e.target.value)}
                                  >
                                    <option value="" disabled selected>Select Question Type</option>
                                    <option value="Inclusion">Inclusion</option>
                                    <option value="Exclusion">Exclusion</option>
                                    <option value="Neutral">Neutral</option>
                                  </select>
                                  <span className="relative right-[50px] top-[10px] transform -translate-y-1/2 pointer-events-none">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                  </span>
                                  <input
                                    type="text"
                                    placeholder={`Question ${index + 1}`}
                                    value={introduction.trialQuestionText}
                                    onChange={(e) => handleQuestionChange(index, "trialQuestionText", e.target.value)}
                                    className="border_color border text-base rounded-lg block w-full p-2.5 mr-8 h-12"
                                    style={{ marginRight: '30px' }}
                                  />

                                  {index === 0 && trialQuestion.length === 1 ? <button
                                    type="button"
                                    disabled={true}
                                    onClick={() => removeQuestionRow(index)}
                                    onMouseEnter={() => { setTrialQuestionDeleteHover(index) }}
                                    onMouseLeave={() => { setTrialQuestionDeleteHover() }}
                                    className="w-8 h-8 text-white rounded-full flex items-center justify-center m-2"
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M18.5172 12.7795L19.26 12.8829L19.26 12.8829L18.5172 12.7795ZM18.2549 14.6645L18.9977 14.7679L18.9977 14.7679L18.2549 14.6645ZM5.74514 14.6645L6.48798 14.5611L6.48798 14.5611L5.74514 14.6645ZM5.4828 12.7795L4.73996 12.8829L4.73996 12.8829L5.4828 12.7795ZM9.18365 21.7368L8.89206 22.4278L8.89206 22.4278L9.18365 21.7368ZM6.47508 18.5603L7.17907 18.3017L7.17907 18.3017L6.47508 18.5603ZM17.5249 18.5603L18.2289 18.819L18.2289 18.819L17.5249 18.5603ZM14.8164 21.7368L14.5248 21.0458L14.5248 21.0458L14.8164 21.7368ZM5.74664 8.92906C5.70746 8.5167 5.34142 8.21418 4.92906 8.25336C4.5167 8.29254 4.21418 8.65858 4.25336 9.07094L5.74664 8.92906ZM19.7466 9.07094C19.7858 8.65858 19.4833 8.29254 19.0709 8.25336C18.6586 8.21418 18.2925 8.5167 18.2534 8.92906L19.7466 9.07094ZM20 7.75C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25V7.75ZM4 6.25C3.58579 6.25 3.25 6.58579 3.25 7C3.25 7.41421 3.58579 7.75 4 7.75V6.25ZM9.25 18C9.25 18.4142 9.58579 18.75 10 18.75C10.4142 18.75 10.75 18.4142 10.75 18H9.25ZM10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10H10.75ZM13.25 18C13.25 18.4142 13.5858 18.75 14 18.75C14.4142 18.75 14.75 18.4142 14.75 18H13.25ZM14.75 10C14.75 9.58579 14.4142 9.25 14 9.25C13.5858 9.25 13.25 9.58579 13.25 10H14.75ZM16 7V7.75H16.75V7H16ZM8 7H7.25V7.75H8V7ZM17.7744 12.6761L17.512 14.5611L18.9977 14.7679L19.26 12.8829L17.7744 12.6761ZM6.48798 14.5611L6.22564 12.6761L4.73996 12.8829L5.0023 14.7679L6.48798 14.5611ZM12 21.25C10.4708 21.25 9.92544 21.2358 9.47524 21.0458L8.89206 22.4278C9.68914 22.7642 10.6056 22.75 12 22.75V21.25ZM5.0023 14.7679C5.282 16.7777 5.43406 17.9017 5.77109 18.819L7.17907 18.3017C6.91156 17.5736 6.77851 16.6488 6.48798 14.5611L5.0023 14.7679ZM9.47524 21.0458C8.55279 20.6566 7.69496 19.7058 7.17907 18.3017L5.77109 18.819C6.3857 20.4918 7.48205 21.8328 8.89206 22.4278L9.47524 21.0458ZM17.512 14.5611C17.2215 16.6488 17.0884 17.5736 16.8209 18.3017L18.2289 18.819C18.5659 17.9017 18.718 16.7777 18.9977 14.7679L17.512 14.5611ZM12 22.75C13.3944 22.75 14.3109 22.7642 15.1079 22.4278L14.5248 21.0458C14.0746 21.2358 13.5292 21.25 12 21.25V22.75ZM16.8209 18.3017C16.305 19.7058 15.4472 20.6566 14.5248 21.0458L15.1079 22.4278C16.5179 21.8328 17.6143 20.4918 18.2289 18.819L16.8209 18.3017ZM6.22564 12.6761C6.00352 11.08 5.83766 9.88703 5.74664 8.92906L4.25336 9.07094C4.34819 10.069 4.51961 11.2995 4.73996 12.8829L6.22564 12.6761ZM19.26 12.8829C19.4804 11.2995 19.6518 10.069 19.7466 9.07094L18.2534 8.92906C18.1623 9.88702 17.9965 11.08 17.7744 12.6761L19.26 12.8829ZM20 6.25H4V7.75H20V6.25ZM10.75 18V10H9.25V18H10.75ZM14.75 18V10H13.25V18H14.75ZM15.25 6V7H16.75V6H15.25ZM16 6.25H8V7.75H16V6.25ZM8.75 7V6H7.25V7H8.75ZM12 2.75C13.7949 2.75 15.25 4.20507 15.25 6H16.75C16.75 3.37665 14.6234 1.25 12 1.25V2.75ZM12 1.25C9.37665 1.25 7.25 3.37665 7.25 6H8.75C8.75 4.20507 10.2051 2.75 12 2.75V1.25Z" fill="#87909E" />
                                    </svg>
                                  </button> : <button
                                    type="button"
                                    onClick={() => removeQuestionRow(index)}
                                    onMouseEnter={() => { setTrialQuestionDeleteHover(index) }}
                                    onMouseLeave={() => { setTrialQuestionDeleteHover() }}
                                    className="w-8 h-8 text-white rounded-full flex items-center justify-center m-2"
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                      <path d="M8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6V7H8V6Z" fill="#DC3545" />
                                      <path d="M18.5172 12.7795L19.26 12.8829L18.5172 12.7795ZM18.2549 14.6645L18.9977 14.7679L18.2549 14.6645ZM5.74514 14.6645L6.48798 14.5611L5.74514 14.6645ZM5.4828 12.7795L4.73996 12.8829L5.4828 12.7795ZM9.18365 21.7368L8.89206 22.4278L9.18365 21.7368ZM6.47508 18.5603L7.17907 18.3017L6.47508 18.5603ZM17.5249 18.5603L18.2289 18.819V18.819L17.5249 18.5603ZM14.8164 21.7368L14.5248 21.0458H14.5248L14.8164 21.7368ZM5.74664 8.92906C5.70746 8.5167 5.34142 8.21418 4.92906 8.25336C4.5167 8.29254 4.21418 8.65858 4.25336 9.07094L5.74664 8.92906ZM19.7466 9.07094C19.7858 8.65858 19.4833 8.29254 19.0709 8.25336C18.6586 8.21418 18.2925 8.5167 18.2534 8.92906L19.7466 9.07094ZM20 7.75C20.4142 7.75 20.75 7.41421 20.75 7C20.75 6.58579 20.4142 6.25 20 6.25V7.75ZM4 6.25C3.58579 6.25 3.25 6.58579 3.25 7C3.25 7.41421 3.58579 7.75 4 7.75V6.25ZM9.25 18C9.25 18.4142 9.58579 18.75 10 18.75C10.4142 18.75 10.75 18.4142 10.75 18H9.25ZM10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10H10.75ZM13.25 18C13.25 18.4142 13.5858 18.75 14 18.75C14.4142 18.75 14.75 18.4142 14.75 18H13.25ZM14.75 10C14.75 9.58579 14.4142 9.25 14 9.25C13.5858 9.25 13.25 9.58579 13.25 10H14.75ZM16 7V7.75H16.75V7H16ZM8 7H7.25V7.75H8V7ZM17.7744 12.6761L17.512 14.5611L18.9977 14.7679L19.26 12.8829L17.7744 12.6761ZM6.48798 14.5611L6.22564 12.6761L4.73996 12.8829L5.0023 14.7679L6.48798 14.5611ZM12 21.25C10.4708 21.25 9.92544 21.2358 9.47524 21.0458L8.89206 22.4278C9.68914 22.7642 10.6056 22.75 12 22.75V21.25ZM5.0023 14.7679C5.282 16.7777 5.43406 17.9017 5.77109 18.819L7.17907 18.3017C6.91156 17.5736 6.77851 16.6488 6.48798 14.5611L5.0023 14.7679ZM9.47524 21.0458C8.55279 20.6566 7.69496 19.7058 7.17907 18.3017L5.77109 18.819C6.3857 20.4918 7.48205 21.8328 8.89206 22.4278L9.47524 21.0458ZM17.512 14.5611C17.2215 16.6488 17.0884 17.5736 16.8209 18.3017L18.2289 18.819C18.5659 17.9017 18.718 16.7777 18.9977 14.7679L17.512 14.5611ZM12 22.75C13.3944 22.75 14.3109 22.7642 15.1079 22.4278L14.5248 21.0458C14.0746 21.2358 13.5292 21.25 12 21.25V22.75ZM16.8209 18.3017C16.305 19.7058 15.4472 20.6566 14.5248 21.0458L15.1079 22.4278C16.5179 21.8328 17.6143 20.4918 18.2289 18.819L16.8209 18.3017ZM6.22564 12.6761C6.00352 11.08 5.83766 9.88703 5.74664 8.92906L4.25336 9.07094C4.34819 10.069 4.51961 11.2995 4.73996 12.8829L6.22564 12.6761ZM19.26 12.8829C19.4804 11.2995 19.6518 10.069 19.7466 9.07094L18.2534 8.92906C18.1623 9.88702 17.9965 11.08 17.7744 12.6761L19.26 12.8829ZM20 6.25H4V7.75H20V6.25ZM10.75 18V10H9.25V18H10.75ZM14.75 18V10H13.25V18H14.75ZM15.25 6V7H16.75V6H15.25ZM16 6.25H8V7.75H16V6.25ZM8.75 7V6H7.25V7H8.75ZM12 2.75C13.7949 2.75 15.25 4.20507 15.25 6H16.75C16.75 3.37665 14.6234 1.25 12 1.25V2.75ZM12 1.25C9.37665 1.25 7.25 3.37665 7.25 6H8.75C8.75 4.20507 10.2051 2.75 12 2.75V1.25Z" fill="#DC3545" />
                                    </svg>
                                  </button>}
                                </div></>
                            ))} */}

                              {error.questionType || error.questionText && <div className="intro-row flex space-x-4  justify-center items-end">
                                <label className="block p-2 pl-0 pt-0 w-1/4">
                                  {error.questionType && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.questionType}</p>}
                                </label>
                                <label className="block w-5/6 p-2  pl-0 pt-0 ml-[6px!important]">
                                  {error.questionText && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.questionText}</p>}
                                </label>
                                <label className="block w-[150px] p-2 pt-0 ">
                                  <div className=" form_label_color  mb-3">
                                  </div>
                                  <div>
                                  </div>
                                </label>
                                <button
                                  type="button"
                                  // onClick={() => deleteRow(index)}
                                  className="w-8 h-8 flex item-end">
                                </button>
                              </div>}
                              <button
                                type="button"
                                onClick={() => addQuestionRow()}
                                className="flex mt-2 items-center"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                  <path d="M9 1V17" stroke="#245CEA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M1 9H17" stroke="#245CEA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg> <span className="ml-2 font-mont text-[16px] font-[600] text-[#245CEA]">Add Question</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="text-[18px] font-mont font-[600] mt-5">Status Messages</div>
                        <div className="border p-5 border-[#C8D6E6] rounded-xl mt-5 mb-[70px]">
                          <div className="space-y-6" >
                            {/* DNQ: Not Qualified Message */}
                            <div className="w-full">
                              <label className="block form_label_color mb-3 ">DNQ: Not Qualified Message <span className="text-red-600">*</span></label>
                              <textarea
                                value={dnqMessage}
                                onChange={(e) => setDnqMessage(e.target.value)}
                                className="border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                              ></textarea>
                              {error.dnqMessage && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.dnqMessage}</p>}
                            </div>

                            {/* On "Booked" Message */}
                            <div className="w-full">
                              <label className="block form_label_color mb-3">On "Booked" Message <span className="text-red-600">*</span></label>
                              <textarea
                                value={bookedMessage}
                                onChange={(e) => setBookedMessage(e.target.value)}
                                className="border_color border text-base rounded-lg block w-full p-2"
                              ></textarea>
                              {error.bookedMessage && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.bookedMessage}</p>}
                            </div>
                          </div>
                        </div>
                      </div>
                       </fieldset>

                      <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-4 bottom-0 w-full bg-white pl-8 flex gap-5">
                        {editMode ? (<>
                          <button type="submit" className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 min-w-[94px]" disabled={apiLoader} onClick={handleAddTrial} >{apiLoader ? <div className="flex justify-center"><div className="mini-spinner "></div></div> : "Save"}</button>
                          <EditTrialsBackButton editTrial={true} />
                        </>) : (<>
                          <button type="button" className="px-[20px] py-[8px] text-[14px] text-base rounded-md border primary_btn  min-w-[94px]" onClick={(e)=> {e.preventDefault(); setEditMode(true);}}>Edit</button>
                        </>)}
                      </div>



                      {isOpen && (
                        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                          <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 relative">
                            <button
                              onClick={closePopup}
                              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                            >
                              ✕
                            </button>
                            <OperatingHours
                              getDataOp={getDataOp}
                              setgetDataOp={setgetDataOp}
                              isOpen={isOpen}
                              setIsOpen={setIsOpen}
                              setInputResponse={setInputResponse}
                              inputResponse={inputResponse}
                            />
                          </div>
                        </div>
                      )
                      }
                     
                    </form>
                  </>
                ) : activeTab === 'Meta Ads Integration' ? (
                  <MetaAdsIntegration
                  addToast={addToast}
                  id={id}
                   />
                ) : activeTab === 'Trial Information' ? (
                  <PatientScreening 
                  addToast={addToast}
                  trialId={id} />
                ) : (<></>)
              }
            </div>
          </div></div>
      </div>
    </>
  )
}


export default WorkflowDetails


